export default __webpack_public_path__ + "static/media/014-traffic-sign.2638938a.png";